import { useState, useEffect } from 'react';
import ct from 'countries-and-timezones';

const useTimeZone = () => {
  const [userTimeZone, setUserTimeZone] = useState('');
  const [countryCode, setCountryCode] = useState('');

  // Function to get country code from time zone
  const getCountryCodeFromTimeZone = (timeZone) => {
    const timeZoneInfo = ct.getTimezone(timeZone);
    if (timeZoneInfo && timeZoneInfo.countries && timeZoneInfo.countries.length > 0) {
      return timeZoneInfo.countries[0].toLowerCase(); // Return the first country code in lowercase
    }
    return 'Unknown';
  };

  useEffect(() => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setUserTimeZone(timeZone);
    const code = getCountryCodeFromTimeZone(timeZone);
    setCountryCode(code);
  }, []);

  return { userTimeZone, countryCode };
};

export default useTimeZone;
